(function ($) {
  'use strict';

  Drupal.behaviors.frontendViewProductGroupProductsOverview = {
    attach: function (context) {

      $('.node-product-group-full__filters-item select', context).on('change', function () {
        var selector = getFilterSelector();

        var $rows = $('.view-product-group-products-overview__row');
        if (selector === '') {
          $rows.toggleClass('view-product-group-products-overview__row--hidden', false);
        }
        else {
          $rows.not(selector).toggleClass('view-product-group-products-overview__row--hidden', true);
          $rows.filter(selector).toggleClass('view-product-group-products-overview__row--hidden', false);
        }
      });
    }
  };

  function getFilterSelector() {
    var selector = '';
    $('.node-product-group-full__filters-item select').each(function () {
      var val = $(this).val();

      if (val !== '_') {
        selector += ['[data-filter-specifications~="' + val + '"]'];
      }
    });

    return selector;
  }

})(jQuery);
